import { ICustomField, ICustomFieldsEntity, IEntity } from '@pf/shared-common';
import {
    AuditCount,
    AuditSearchRequestParams,
    AuditStatus,
    AuditTypeFragment,
    AuditViewModelCreateBody,
    AuditViewModelRead,
    InventoryBundleFragment,
    ItemFragment,
    ResourceAuth,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import { isValue } from '@pf/shared-utility';

export type AuditRead = AuditViewModelRead & IEntity;
export type AuditCreate = AuditViewModelCreateBody;
export type AuditSearchParams = AuditSearchRequestParams;

export function HasMatchingCount(audit: AuditDto) {
    return (
        audit.status === AuditStatus.Completed &&
        audit.auditCounts.some(
            count =>
                isValue(count.actualQuantity) &&
                count.actualQuantity === count.auditQuantity
        )
    );
}

export class AuditDto implements IEntity, ICustomFieldsEntity {
    constructor(data: Partial<AuditDto>) {
        Object.assign(this, data);
    }

    assignedTo?: string | null;
    auditDate?: string | null;
    priority?: string | null;
    status?: AuditStatus | null;
    resourceAuth?: ResourceAuth;
    startDate?: string | null;
    dueDate?: string | null;
    item?: ItemFragment;
    inventoryBundle?: InventoryBundleFragment;
    warehouse?: WarehouseFragment;
    auditType?: AuditTypeFragment;
    customFields?: Array<ICustomField>;
    id!: string;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
    auditScheduleId?: string | null;
    auditCounts: Array<AuditCount> = [];
}
